<div class="w-full max-w-3xl">
    <!-- Form -->
    <form [formGroup]="accountForm">

        <!-- Divider -->
        <div class="my-10 border-t"></div>
        <!-- Section -->
        <div class="w-full mb-3">
            <div class="text-xl">Mis datos</div>
            <!-- <div class="text-secondary">Communication details in case we want to connect with you. These will be kept private.</div> -->
        </div>
        <!-- Section -->
        <div class="w-full">
            <!-- <div class="text-xl"><b>{{ operacion?.attributes?.rfc.toUpperCase() }}</b></div> -->
            <!-- Operaciones -->
            <div class="sm:col-span-2">
                <mat-form-field class="fuse-mat-no-subscript w-full">
                    <mat-label>RFC</mat-label>
                    <input matInput [formControlName]="'rfc'" [disabled]="!idEmpresa" maxlength="13">
                    
                </mat-form-field>
                <ng-container *ngIf="accountForm.controls['idOperacion'].invalid && (accountForm.controls['idOperacion'].dirty || accountForm.controls['idOperacion'].touched)">
                    <div *ngIf="accountForm.controls['idOperacion'].errors?.['required']" class="mt-1 text-md text-hint text-danger">
                        Este campo es requerido
                    </div>
                </ng-container>
            </div>
            <div class="text-secondary">La siguiente información se tomara para la creación de tus facturas!</div>
        </div>
        <div>
            <app-upload-files *ngIf="operacion" [title]="'Logotipo'" [accept]="'.jpg,.png,jpeg'" [idOperacion]="operacion.idOperacion" [disabled]="false" [files]="files" [api]="api" [dataField]="dataField" [show]="true" (uploaded)="getOperacion()"></app-upload-files>
        </div>
        <div class="grid sm:grid-cols-4 gap-6 w-full mt-8">
            <!-- Tipo de persoa -->
            <div class="sm:col-span-2">
                <mat-form-field class="fuse-mat-no-subscript w-full">
                    <mat-label>Tipo de persona</mat-label>
                    <mat-select [formControlName]="'idTipoPersona'" (ngModelChange)="setDataGiro()">
                        <mat-option *ngFor="let item of catTipoPersona" [value]="item.id"> {{ item.attributes.nombre }} </mat-option>
                    </mat-select>
                </mat-form-field>
                <ng-container *ngIf="accountForm.controls['idTipoPersona'].invalid && (accountForm.controls['idTipoPersona'].dirty || accountForm.controls['idTipoPersona'].touched)">
                    <div *ngIf="accountForm.controls['idTipoPersona'].errors?.['required']" class="mt-1 text-md text-hint text-danger">
                        Este campo es requerido
                    </div>
                </ng-container>
            </div>

            <!-- Tamaño empresa -->
            <div class="sm:col-span-2">
                <mat-form-field class="fuse-mat-no-subscript w-full">
                    <mat-label>Giro u ocupación</mat-label>
                    <mat-select [formControlName]="'idGiro'">
                        <mat-option *ngFor="let item of catGiro" [value]="item.id"> {{ item.attributes.nombre }} </mat-option>
                    </mat-select>
                </mat-form-field>
                <ng-container *ngIf="accountForm.controls['idGiro'].invalid && (accountForm.controls['idGiro'].dirty || accountForm.controls['idGiro'].touched)">
                    <div *ngIf="accountForm.controls['idGiro'].errors?.['required']" class="mt-1 text-md text-hint text-danger">
                        Este campo es requerido
                    </div>
                </ng-container>
            </div>

            <!-- Razón social -->
            <div class="sm:col-span-4">
                <mat-form-field class="fuse-mat-no-subscript w-full">
                    <mat-label>Nombre o Razón social</mat-label>
                    <input
                        [formControlName]="'razonSocial'"
                        maxlength="350"
                        matInput>
                </mat-form-field>
                <ng-container *ngIf="accountForm.controls['razonSocial'].invalid && (accountForm.controls['razonSocial'].dirty || accountForm.controls['razonSocial'].touched)">
                    <div *ngIf="accountForm.controls['razonSocial'].errors?.['required']" class="mt-1 text-md text-hint text-danger">
                        Este campo es requerido
                    </div>
                </ng-container>
            </div>

            <!-- Nombre comercial -->
            <div class="sm:col-span-4">
                <mat-form-field class="fuse-mat-no-subscript w-full">
                    <mat-label>Nombre comercial</mat-label>
                    <input
                        [formControlName]="'nombreComercial'"
                        maxlength="350"
                        matInput>
                </mat-form-field>
                <div class="mt-1 text-md text-hint">Si no tienes nombre comercial proporciona tu nombre.</div>
                <ng-container *ngIf="accountForm.controls['nombreComercial'].invalid && (accountForm.controls['nombreComercial'].dirty || accountForm.controls['nombreComercial'].touched)">
                    <div *ngIf="accountForm.controls['nombreComercial'].errors?.['required']" class="mt-1 text-md text-hint text-danger">
                        Este campo es requerido
                    </div>
                </ng-container>
            </div>

            <!-- Régimen fiscal -->
            <div class="sm:col-span-4">
                <mat-form-field class="fuse-mat-no-subscript w-full">
                    <mat-label>Régimen fiscal</mat-label>
                    <mat-select [formControlName]="'idRegimenFiscal'">
                        <mat-option *ngFor="let item of catReg" [value]="item.id"> {{ item.attributes.clave }} - {{ item.attributes.descripcion }} </mat-option>
                    </mat-select>
                </mat-form-field>
                <ng-container *ngIf="accountForm.controls['idRegimenFiscal'].invalid && (accountForm.controls['idRegimenFiscal'].dirty || accountForm.controls['idRegimenFiscal'].touched)">
                    <div *ngIf="accountForm.controls['idRegimenFiscal'].errors?.['required']" class="mt-1 text-md text-hint text-danger">
                        Este campo es requerido
                    </div>
                </ng-container>
            </div>

            <!-- Tamaño empresa -->
            <div class="sm:col-span-2">
                <mat-form-field class="fuse-mat-no-subscript w-full">
                    <mat-label>Tamaño de la empresa</mat-label>
                    <mat-select [formControlName]="'idTamanioEmpresa'">
                        <mat-option *ngFor="let item of catTamanio" [value]="item.id"> {{ item.attributes.descripcion }} </mat-option>
                    </mat-select>
                </mat-form-field>
                <ng-container *ngIf="accountForm.controls['idTamanioEmpresa'].invalid && (accountForm.controls['idTamanioEmpresa'].dirty || accountForm.controls['idTamanioEmpresa'].touched)">
                    <div *ngIf="accountForm.controls['idTamanioEmpresa'].errors?.['required']" class="mt-1 text-md text-hint text-danger">
                        Este campo es requerido
                    </div>
                </ng-container>
            </div>

            <!-- E-mail -->
            <div class="sm:col-span-2">
                <mat-form-field class="fuse-mat-no-subscript w-full">
                    <mat-label>E-mail de contacto</mat-label>
                    <input
                        [formControlName]="'contactoEmail'"
                        matInput>
                </mat-form-field>
                <ng-container *ngIf="accountForm.controls['contactoEmail'].invalid && (accountForm.controls['contactoEmail'].dirty || accountForm.controls['contactoEmail'].touched)">
                    <div *ngIf="accountForm.controls['contactoEmail'].errors?.['required']" class="mt-1 text-md text-hint text-danger">
                        Este campo es requerido
                    </div>
                    <div *ngIf="accountForm.controls['contactoEmail'].errors?.['email']" class="mt-1 text-md text-hint text-danger">
                        Debe ingresar un correo electrónico
                    </div>
                </ng-container>
            </div>

            <!-- Número de celular para notificaciones -->
            <div class="sm:col-span-2">
                <mat-form-field class="fuse-mat-no-subscript w-full">
                    <mat-label>Número de celular para notificaciones</mat-label>
                    <input
                        maxlength="14"
                        [formControlName]="'contactoTelefono'"
                        matInput>
                </mat-form-field>
                <ng-container *ngIf="accountForm.controls['contactoTelefono'].invalid && (accountForm.controls['contactoTelefono'].dirty || accountForm.controls['contactoTelefono'].touched)">
                    <div *ngIf="accountForm.controls['contactoTelefono'].errors?.['required']" class="mt-1 text-md text-hint text-danger">
                        Este campo es requerido
                    </div>
                </ng-container>
            </div>
        </div>

        <!-- Actions -->
        <div class="flex items-center justify-end mt-8">
            <button *ngIf="idEmpresa"
                class="ml-4"
                mat-flat-button
                type="button"
                [disabled]="!accountForm.valid"
                (click)="actualizarEmpresa()"
                [color]="'primary'">Actualizar
            </button>
            <button *ngIf="!idEmpresa"
                class="ml-4"
                mat-flat-button
                type="button"
                [disabled]="!accountForm.valid"
                (click)="guardarEmpresa()"
                [color]="'primary'">Guardar
            </button>
        </div>
    </form>

    
</div>